function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LossTemplate = require('./loss.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LossOverlay = /*#__PURE__*/function () {
  function LossOverlay(app, mod) {
    _classCallCheck(this, LossOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.assignment_faction = '';
    this.i_am_assigning = false;
    this.faction = '';
    this.units = null;
    this.loss_factor = 0;
    this.starting_units = null;
    this.starting_loss_factor = null;
    this.moves = [];
    this.number_of_hits_assignable_attacker_units = 0;
    this.number_of_hits_assignable_defender_units = 0;
    this.sole_attacker_unit = null;
    this.sole_defender_unit = null;
    this.sole_attacker_unit_id = null;
    this.sole_defender_unit_id = null;
    this.sole_defender_unit_id = null;
    this.my_hits_auto_assigned = 0;
    this.hits_already_assigned = 0;
    this.priority_hits_required = 0;
    this.are_any_units_unassignable = 0;
    this.board_mode = false;
    this.board_spaces = [];
    this.board_opened_spaces = [];
    this.board_bind = null;
    this.board_hover_bound = false;
  }
  return _createClass(LossOverlay, [{
    key: "show",
    value: function show() {
      this.overlay.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }

    // Overlay is the default guided experience. Pref 0 opts into board assignment.
  }, {
    key: "overlayEnabled",
    value: function overlayEnabled() {
      var pref = this.mod.loadGamePreference('pathsofglory_show_combat_overlays');
      if (pref === 0 || pref === '0' || pref === false) {
        return false;
      }
      return true;
    }
  }, {
    key: "setOverlayEnabled",
    value: function setOverlayEnabled(enabled) {
      this.mod.saveGamePreference('pathsofglory_show_combat_overlays', enabled ? 1 : 0);
    }
  }, {
    key: "bindOverlayPreferenceControl",
    value: function bindOverlayPreferenceControl() {
      var _this = this;
      var input = document.querySelector('.loss-overlay .loss-overlay-use-board');
      if (!input) {
        return;
      }
      input.checked = !this.overlayEnabled();
      input.onchange = function (e) {
        var use_board = !!e.currentTarget.checked;
        _this.setOverlayEnabled(!use_board);
        if (use_board) {
          _this.hide();
          _this.enterBoardMode();
          if (_this.i_am_assigning && _this.board_bind) {
            _this.attachEvents(_this.board_bind.am_i_the_attacker, _this.board_bind.my_qs, _this.board_bind.faction, _this.board_bind.just_one_more_hit);
          } else {
            _this.refreshBoardAssignmentUI();
            _this.updateBoardHud();
          }
        }
      };
    }
  }, {
    key: "participatingSpaces",
    value: function participatingSpaces() {
      var keys = {};
      var add = function add(units) {
        for (var i = 0; i < units.length; i++) {
          var u = units[i];
          if (!u || u.destroyed) {
            continue;
          }
          if (u.spacekey) {
            keys[u.spacekey] = 1;
          }
        }
      };
      add(this.mod.returnAttackerUnits());
      add(this.mod.returnDefenderUnits());
      return Object.keys(keys);
    }
  }, {
    key: "updateBoardHud",
    value: function updateBoardHud() {
      if (!this.board_mode) {
        return;
      }
      var msg = '';
      if (this.i_am_assigning) {
        if (this.board_bind && this.board_bind.just_one_more_hit) {
          msg = 'Take additional hit to cancel retreat';
        } else {
          msg = "Assign ".concat(this.loss_factor, " hit").concat(this.loss_factor == 1 ? '' : 's');
        }
      } else {
        msg = 'Opponent Assigning Losses';
      }
      this.mod.game.status = msg;
      this.mod.hud.updateStatus(msg);
      this.mod.hud.updateMenu([]);
      this.mod.hud.updateCards([]);
    }
  }, {
    key: "drawOrderForSpace",
    value: function drawOrderForSpace(spacekey) {
      var space = this.mod.game.spaces[spacekey];
      if (!space) {
        return [];
      }
      var draw_units = space.units.slice();
      draw_units.sort(function (a, b) {
        var am = a.damaged ? a.rmovement : a.movement;
        var bm = b.damaged ? b.rmovement : b.movement;
        return (am || 0) - (bm || 0);
      });
      return draw_units;
    }
  }, {
    key: "layoutBoardStack",
    value: function layoutBoardStack(spacekey) {
      var _this2 = this;
      var el = document.getElementById(spacekey);
      if (!el) {
        return;
      }
      var tiles = el.querySelectorAll(':scope > .army-tile');
      if (tiles.length < 1) {
        return;
      }
      this.rememberOpenedSpace(spacekey);
      var size = el.offsetWidth || 90;
      var gap = Math.round(size * 0.08);
      var pad = Math.round(size * 0.16);
      var total = tiles.length * size + Math.max(0, tiles.length - 1) * gap;
      var start = (size - total) / 2;
      el.classList.add('stack-open', 'loss-assignment-open');
      if (!el.style.zIndex || parseInt(el.style.zIndex) < 80) {
        el.style.zIndex = '80';
      }
      el.style.setProperty('--stack-top', start - pad + 'px');
      el.style.setProperty('--stack-height', total + pad * 2 + 'px');
      el.style.setProperty('--stack-width', size + pad * 2 + 'px');
      tiles.forEach(function (tile, i) {
        tile.style.top = start + i * (size + gap) + 'px';
        tile.style.left = '0px';
        tile.style.width = size + 'px';
        tile.style.height = size + 'px';
        tile.style.zIndex = String(20 + i);
      });
      el.onmouseenter = function () {
        if (_this2.board_mode) {
          el.style.zIndex = '95';
        }
      };
      el.onmouseleave = function () {
        if (_this2.board_mode) {
          el.style.zIndex = '80';
        }
      };
    }
  }, {
    key: "isCombatParticipant",
    value: function isCombatParticipant(unit) {
      if (!unit || unit.destroyed) {
        return false;
      }
      var attackers = this.mod.returnAttackerUnits();
      if (attackers.indexOf(unit) >= 0) {
        return true;
      }
      var defenders = this.mod.returnDefenderUnits();
      return defenders.indexOf(unit) >= 0;
    }
  }, {
    key: "isAttackerSourceSpace",
    value: function isAttackerSourceSpace(spacekey) {
      var combat = this.mod.game.state && this.mod.game.state.combat;
      if (!combat || !combat.attacker) {
        return false;
      }
      for (var z = 0; z < combat.attacker.length; z++) {
        if (combat.attacker[z].unit_sourcekey === spacekey) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "annotateBoardTiles",
    value: function annotateBoardTiles(spacekey) {
      var _this3 = this;
      var el = document.getElementById(spacekey);
      if (!el) {
        return;
      }
      var draw_units = this.drawOrderForSpace(spacekey);
      var tiles = el.querySelectorAll(':scope > .army-tile');
      var attacker_source = this.isAttackerSourceSpace(spacekey);
      tiles.forEach(function (tile, i) {
        tile.classList.remove('loss-board-unit', 'loss-board-unassignable', 'loss-board-other', 'loss-board-participant');
        delete tile.dataset.lossIdx;
        tile.onclick = null;
        var unit = draw_units[i];
        if (!unit) {
          return;
        }
        var idx = _this3.units ? _this3.units.indexOf(unit) : -1;
        var participating = _this3.isCombatParticipant(unit);
        // Assignable side this step — clickable; opacity stays full even if unassignable.
        if (idx >= 0 && !unit.destroyed) {
          tile.dataset.lossIdx = String(idx);
          tile.classList.add('loss-board-unit');
          return;
        }
        // Other combat participants (e.g. opponent) stay fully visible.
        if (participating) {
          tile.classList.add('loss-board-participant');
          return;
        }
        // Only nonparticipating units in attacker source spaces are subdued.
        if (attacker_source) {
          tile.classList.add('loss-board-other');
        }
      });
    }
  }, {
    key: "shakeBoardTile",
    value: function shakeBoardTile(tile) {
      if (!tile || tile.classList.contains('shake')) {
        return;
      }
      tile.classList.add('shake');
      setTimeout(function () {
        tile.classList.remove('shake');
      }, 1500);
    }

    // Opponent-assigned hit: shake the specific chit after the space has been redrawn.
  }, {
    key: "animateBoardHit",
    value: function animateBoardHit(spacekey, unitkey, unit_idx) {
      if (!this.board_mode || !spacekey || !unitkey) {
        return;
      }
      var el = document.getElementById(spacekey);
      if (!el) {
        return;
      }
      var space = this.mod.game.spaces[spacekey];
      if (!space) {
        return;
      }
      var unit = null;
      var z = parseInt(unit_idx);
      if (!isNaN(z) && space.units[z] && space.units[z].key === unitkey) {
        unit = space.units[z];
      }
      if (!unit) {
        for (var i = 0; i < space.units.length; i++) {
          var u = space.units[i];
          if (u && u.key === unitkey && u.damaged_this_combat) {
            unit = u;
            break;
          }
        }
      }
      if (!unit) {
        for (var _i = 0; _i < space.units.length; _i++) {
          if (space.units[_i] && space.units[_i].key === unitkey) {
            unit = space.units[_i];
            break;
          }
        }
      }
      if (!unit) {
        return;
      }
      var draw_units = this.drawOrderForSpace(spacekey);
      var di = draw_units.indexOf(unit);
      var tiles = el.querySelectorAll(':scope > .army-tile');
      if (di >= 0 && tiles[di]) {
        this.shakeBoardTile(tiles[di]);
      }
    }
  }, {
    key: "clearBoardStack",
    value: function clearBoardStack(spacekey) {
      var el = document.getElementById(spacekey);
      if (!el) {
        return;
      }
      el.classList.remove('stack-open', 'loss-assignment-open');
      el.style.zIndex = '';
      el.style.removeProperty('--stack-top');
      el.style.removeProperty('--stack-height');
      el.style.removeProperty('--stack-width');
      el.onmouseenter = null;
      el.onmouseleave = null;
      el.querySelectorAll(':scope > .army-tile').forEach(function (tile) {
        tile.style.top = '';
        tile.style.left = '';
        tile.style.width = '';
        tile.style.height = '';
        tile.style.zIndex = '';
        tile.classList.remove('loss-board-unit', 'loss-board-unassignable', 'loss-board-other', 'loss-board-participant');
        delete tile.dataset.lossIdx;
        tile.onclick = null;
      });
    }
  }, {
    key: "rememberOpenedSpace",
    value: function rememberOpenedSpace(spacekey) {
      if (!spacekey) {
        return;
      }
      if (!this.board_opened_spaces) {
        this.board_opened_spaces = [];
      }
      if (this.board_opened_spaces.indexOf(spacekey) === -1) {
        this.board_opened_spaces.push(spacekey);
      }
    }
  }, {
    key: "collectBoardCleanupSpaces",
    value: function collectBoardCleanupSpaces() {
      var keys = {};
      var add = function add(spacekey) {
        if (spacekey) {
          keys[spacekey] = 1;
        }
      };
      for (var i = 0; i < this.board_spaces.length; i++) {
        add(this.board_spaces[i]);
      }
      var opened = this.board_opened_spaces || [];
      for (var _i2 = 0; _i2 < opened.length; _i2++) {
        add(opened[_i2]);
      }
      try {
        document.querySelectorAll('.space.loss-assignment-open').forEach(function (el) {
          add(el.id);
        });
      } catch (err) {}
      return Object.keys(keys);
    }

    // Tear down temporary board presentation before any normal re-render.
    // Idempotent: safe if completion, retreat, or a later render all call it.
  }, {
    key: "exitBoardMode",
    value: function exitBoardMode() {
      var spaces = this.collectBoardCleanupSpaces();
      this.board_mode = false;
      this.board_spaces = [];
      this.board_opened_spaces = [];
      this.board_bind = null;
      for (var i = 0; i < spaces.length; i++) {
        this.clearBoardStack(spaces[i]);
      }
      for (var _i3 = 0; _i3 < spaces.length; _i3++) {
        this.mod.displaySpace(spaces[_i3]);
      }
      this.mod.displaySpace('aeubox');
      this.mod.displaySpace('arbox');
      this.mod.displaySpace('ceubox');
      this.mod.displaySpace('crbox');
    }
  }, {
    key: "enterBoardMode",
    value: function enterBoardMode() {
      if (this.mod.zoom_overlay) {
        try {
          this.mod.zoom_overlay.hide();
        } catch (err) {}
      }
      try {
        this.mod.hideSpaceStack();
      } catch (err) {}
      this.board_mode = true;
      this.board_opened_spaces = [];
      this.board_spaces = this.participatingSpaces();
      this.refreshBoardAssignmentUI();
      this.updateBoardHud();
    }
  }, {
    key: "refreshBoardAssignmentUI",
    value: function refreshBoardAssignmentUI() {
      if (!this.board_mode) {
        return;
      }
      var previous = this.board_spaces.slice();
      var next = this.participatingSpaces();
      this.board_spaces = next;
      for (var i = 0; i < next.length; i++) {
        this.rememberOpenedSpace(next[i]);
      }

      // Spaces whose last assignable units were destroyed must not keep
      // the expanded loss-assignment presentation after they drop out.
      for (var _i4 = 0; _i4 < previous.length; _i4++) {
        var key = previous[_i4];
        if (next.indexOf(key) === -1) {
          this.clearBoardStack(key);
          this.mod.displaySpace(key);
        }
      }
      for (var _i5 = 0; _i5 < next.length; _i5++) {
        var _key = next[_i5];
        this.mod.displaySpace(_key);
        this.layoutBoardStack(_key);
        this.annotateBoardTiles(_key);
      }
      this.mod.displaySpace('aeubox');
      this.mod.displaySpace('arbox');
      this.mod.displaySpace('ceubox');
      this.mod.displaySpace('crbox');
      this.syncUnassignableUI();
    }
  }, {
    key: "onBoardSpaceRedrawn",
    value: function onBoardSpaceRedrawn(spacekey) {
      if (!this.board_mode) {
        return;
      }
      if (this.board_spaces.indexOf(spacekey) == -1) {
        return;
      }
      this.layoutBoardStack(spacekey);
      this.annotateBoardTiles(spacekey);
      if (this.i_am_assigning && this.board_bind) {
        this.bindBoardClicks(this.board_bind.am_i_the_attacker, this.board_bind.my_qs, this.board_bind.faction, this.board_bind.just_one_more_hit);
      }
      this.syncUnassignableUI();
    }
  }, {
    key: "bindBoardClicks",
    value: function bindBoardClicks(am_i_the_attacker, my_qs, faction) {
      var _this4 = this;
      var just_one_more_hit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      document.querySelectorAll('.space.loss-assignment-open .army-tile.loss-board-unit').forEach(function (tile) {
        tile.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this4.updateAssignableUnits();
          var idx = parseInt(e.currentTarget.dataset.lossIdx);
          if (isNaN(idx) || !_this4.units || !_this4.units[idx]) {
            return;
          }
          var unit = _this4.units[idx];
          if (just_one_more_hit) {
            if (unit.damaged) {
              var others = 0;
              for (var z = 0; z < _this4.units.length; z++) {
                if (z != idx && _this4.units[z].destroyed == false) {
                  others++;
                }
              }
              if (others == 0) {
                _this4.rejectInvalidHitAssignment(e.currentTarget);
                return;
              }
            }
          } else {
            if (unit.unassignable == 1) {
              _this4.rejectInvalidHitAssignment(e.currentTarget);
              return;
            }
          }

          // Pass el=null so overlay card DOM updates are skipped; board refresh redraws chits.
          _this4.assignHitToUnit(unit, unit.spacekey, unit.key, idx, null, am_i_the_attacker, my_qs, faction, just_one_more_hit);
          _this4.hits_already_assigned = 1;
        };
      });
    }
  }, {
    key: "canTakeMoreLosses",
    value: function canTakeMoreLosses() {
      if (this.loss_factor == 0) {
        return false;
      }
      var x = [];
      for (var i = 0; i < this.units.length; i++) {
        x.push([]);
        if (this.units[i].damaged == false) {
          x[i].push(this.units[i].loss);
        } else {
          if (this.units[i].destroyed == false) {
            x[i].push(this.units[i].rloss);
            if (this.units[i].key.indexOf('army') > 0) {
              try {
                var corpskey = this.units[i].key.split('_')[0] + '_corps';
                var cunit = this.mod.cloneUnit(corpskey);
                x[i].push(cunit.loss);
                x[i].push(cunit.rloss);
              } catch (err) {
                // some armies cannot be reduced to corps
              }
            }
          }
        }
      }
      for (var _i6 = 0; _i6 < x.length; _i6++) {
        if (this.loss_factor >= x[_i6][0]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "showRetreatNotice",
    value: function showRetreatNotice() {
      var _this5 = this;
      if (this.board_mode || !this.overlayEnabled()) {
        this.exitBoardMode();
        this.mod.game.status = 'Combat resolved';
        this.mod.hud.updateStatus(this.mod.game.status);
        this.mod.hud.updateMenu([]);
        return;
      }
      // The assignment panel is already open. Rebuilding it here spends the
      // loss factor again and hides the overlay before painting it a second time.
      if (!document.querySelector('.loss-overlay')) {
        this.render(this.faction || this.assignment_faction || 'defender', false);
      } else {
        this.show();
      }
      try {
        this.updateInstructions("<div class=\"continue_btn\">All possible damage assigned \u2014 <span style=\"text-decoration:underline dashed;cursor:pointer\">Close to Continue</span></div>", 'resolved');
        var btn = document.querySelector('.loss-overlay .continue_btn');
        if (btn) {
          btn.onclick = function (e) {
            _this5.hide();
          };
        }
      } catch (err) {}
    }
  }, {
    key: "viewingPlayerPower",
    value: function viewingPlayerPower() {
      return this.mod.returnFactionOfPlayer() || '';
    }
  }, {
    key: "activeAssigningPower",
    value: function activeAssigningPower() {
      var combat = this.mod.game.state.combat;
      if (!combat) {
        return '';
      }
      var side = this.assignment_faction || this.faction || '';
      if (side === 'attacker') {
        return combat.attacker_power;
      }
      if (side === 'defender') {
        return combat.defender_power;
      }
      return '';
    }

    // Header color/icon = viewing player's faction (not attacker/defender/assigner).
  }, {
    key: "syncActiveHeader",
    value: function syncActiveHeader() {
      var power = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var status = document.querySelector('.loss-overlay .loss-overlay-status');
      var icon = document.querySelector('.loss-overlay .loss-overlay-status-icon');
      if (!power) {
        power = this.viewingPlayerPower();
      }
      if (status) {
        status.classList.remove('is-central', 'is-allies');
        if (power === 'central') {
          status.classList.add('is-central');
        } else if (power) {
          status.classList.add('is-allies');
        }
      }
      if (icon) {
        icon.dataset.faction = power || '';
      }
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (this.board_mode) {
        this.updateBoardHud();
        return;
      }
      var status = document.querySelector('.loss-overlay .loss-overlay-status');
      var copy = document.querySelector('.loss-overlay .loss-overlay-status-copy');
      if (!status || !copy) {
        return;
      }
      var resolved = mode === 'resolved' || /automatically assigned|all possible damage|combat resolved/i.test(String(msg));
      var action = mode === 'action' || !resolved && this.i_am_assigning && /assign/i.test(String(msg));
      var waiting = mode === 'waiting' || !resolved && !action;
      status.classList.toggle('is-resolved', resolved);
      status.classList.toggle('is-action', action && !resolved);
      status.classList.toggle('is-waiting', waiting && !resolved);
      this.syncActiveHeader();

      // Title stays "Assign losses" during the assignment phase (action or waiting);
      // subtitle carries who is assigning / how much.
      var title = resolved ? 'Combat resolved' : 'Assign losses';
      if (/take additional hit/i.test(String(msg))) {
        title = 'Cancel retreat?';
      }
      copy.innerHTML = "<strong>".concat(title, "</strong><span class=\"status-sub\">").concat(msg, "</span>");
      this.updateCasualtyLines(resolved);
    }
  }, {
    key: "rememberCombatRoster",
    value: function rememberCombatRoster() {
      var attacker_units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var defender_units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var game = this.mod.game;
      var combat = game && game.state && game.state.combat;
      var step = combat ? combat.step : undefined;
      if (this.roster && this.roster.step === step) {
        return;
      }
      this.roster = {
        step: step,
        attacker: attacker_units.slice(),
        defender: defender_units.slice()
      };
    }
  }, {
    key: "casualtySummary",
    value: function casualtySummary() {
      var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var eliminated = [];
      var damaged = [];
      for (var i = 0; i < units.length; i++) {
        var unit = units[i];
        if (!unit) {
          continue;
        }
        var name = unit.name || unit.key;
        var eliminated_box = unit.spacekey === 'aeubox' || unit.spacekey === 'ceubox';
        if (unit.destroyed || eliminated_box) {
          eliminated.push(name);
        } else if (unit.damaged_this_combat && unit.damaged) {
          damaged.push(name);
        }
      }
      if (eliminated.length) {
        return "Eliminated: ".concat(eliminated.join(', '));
      }
      if (damaged.length) {
        return "Damaged: ".concat(damaged.join(', '));
      }
      return '';
    }
  }, {
    key: "updateCasualtyLines",
    value: function updateCasualtyLines() {
      var resolved = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var attacker_el = document.querySelector('.loss-overlay .attacker-casualty');
      var defender_el = document.querySelector('.loss-overlay .defender-casualty');
      if (!attacker_el || !defender_el) {
        return;
      }
      if (!resolved || !this.roster) {
        attacker_el.textContent = '';
        defender_el.textContent = '';
        return;
      }
      attacker_el.textContent = this.casualtySummary(this.roster.attacker);
      defender_el.textContent = this.casualtySummary(this.roster.defender);
    }
  }, {
    key: "summarizeForce",
    value: function summarizeForce() {
      var units = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var armies = 0;
      var corps = 0;
      for (var i = 0; i < units.length; i++) {
        if (units[i].destroyed) {
          continue;
        }
        if (units[i].army || units[i].key && units[i].key.indexOf('army') > -1) {
          armies++;
        } else {
          corps++;
        }
      }
      var parts = [];
      if (armies > 0) {
        parts.push("".concat(armies, " Arm").concat(armies === 1 ? 'y' : 'ies'));
      }
      if (corps > 0) {
        parts.push("".concat(corps, " Corps"));
      }
      return parts.length ? parts.join(', ') : 'No units';
    }
  }, {
    key: "terrainIcon",
    value: function terrainIcon() {
      var terrain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (terrain === 'forest') {
        return '🌲';
      }
      if (terrain === 'mountain') {
        return '⛰';
      }
      if (terrain === 'swamp') {
        return '🌿';
      }
      if (terrain === 'desert') {
        return '☀';
      }
      return '⚔';
    }
  }, {
    key: "fireSnapshot",
    value: function fireSnapshot() {
      var c = this.mod.game.state.combat;
      var attacker_hits = c.attacker_loss_factor_at_fire != null ? c.attacker_loss_factor_at_fire : c.attacker_loss_factor;
      var defender_hits = c.defender_loss_factor_at_fire != null ? c.defender_loss_factor_at_fire : c.defender_loss_factor;

      // Attacker flank: defender fires after taking losses. defender_cp stays "?"
      // until that fire is recalculated on the reduced force.
      if (c.flank_attack == 'attacker') {
        if (c.defender_cp == '?') {
          attacker_hits = '?';
        } else {
          attacker_hits = c.attacker_loss_factor;
        }
      }
      // Defender flank: attacker fires after taking losses.
      if (c.flank_attack == 'defender') {
        if (c.attacker_cp == '?') {
          defender_hits = '?';
        } else {
          defender_hits = c.defender_loss_factor;
        }
      }
      return {
        attacker_cp: c.attacker_cp_at_fire != null ? c.attacker_cp_at_fire : c.attacker_cp,
        defender_cp: c.defender_cp_at_fire != null ? c.defender_cp_at_fire : c.defender_cp,
        attacker_hits: attacker_hits,
        defender_hits: defender_hits
      };
    }
  }, {
    key: "fillPresentationChrome",
    value: function fillPresentationChrome(attacker_units, defender_units) {
      var combat = this.mod.game.state.combat;
      var space = this.mod.game.spaces[combat.key];
      var snap = this.fireSnapshot();
      var terrain = space.terrain || 'clear';
      var show_terrain = !!terrain && terrain !== 'normal' && terrain !== 'clear';
      var show_fort = space.fort > 0;
      var title = document.querySelector('.loss-overlay .loss-overlay-title');
      var space_name = this.mod.returnSpaceName(combat.key);
      var attacker_label = combat.attacker_power === 'central' ? 'Central Powers' : 'Allied Powers';
      if (title) {
        title.innerHTML = "Combat at ".concat(space_name, " - ").concat(attacker_label, " attack");
      }
      var terrain_item = document.querySelector('.loss-overlay .loss-overlay-terrain-item');
      var fort_item = document.querySelector('.loss-overlay .loss-overlay-fort-item');
      var terrain_name = document.querySelector('.loss-overlay .loss-overlay-terrain-name');
      var fort_name = document.querySelector('.loss-overlay .loss-overlay-fort-name');
      if (terrain_item && terrain_name) {
        if (show_terrain) {
          terrain_name.innerHTML = terrain;
          terrain_item.hidden = false;
        } else {
          terrain_name.innerHTML = '';
          terrain_item.hidden = true;
        }
      }
      if (fort_item && fort_name) {
        if (show_fort) {
          fort_name.innerHTML = 'Fortified';
          fort_item.hidden = false;
        } else {
          fort_name.innerHTML = '';
          fort_item.hidden = true;
        }
      }
      var attacker_panel = document.querySelector('.loss-overlay .attacker-panel');
      var defender_panel = document.querySelector('.loss-overlay .defender-panel');
      if (attacker_panel) {
        attacker_panel.classList.remove('is-central', 'is-allies');
        attacker_panel.classList.add(combat.attacker_power === 'central' ? 'is-central' : 'is-allies');
      }
      if (defender_panel) {
        defender_panel.classList.remove('is-central', 'is-allies');
        defender_panel.classList.add(combat.defender_power === 'central' ? 'is-central' : 'is-allies');
      }

      // Orient panels from the local player's perspective: own side left, opponent right.
      var body = document.querySelector('.loss-overlay .loss-overlay-body');
      var my_power = this.viewingPlayerPower();
      if (body) {
        body.classList.toggle('own-side-left', my_power === combat.defender_power);
      }
      var a_hits = document.querySelector('.loss-overlay .attacker-hits-count');
      var d_hits = document.querySelector('.loss-overlay .defender-hits-count');
      // Hits = damage this side generated against the opponent (not hits they absorb)
      if (a_hits) {
        a_hits.innerHTML = snap.defender_hits;
      }
      if (d_hits) {
        d_hits.innerHTML = snap.attacker_hits;
      }
      this.syncActiveHeader();
      var details_btn = document.querySelector('.loss-overlay .loss-overlay-see-details');
      var details = document.querySelector('.loss-overlay .loss-overlay-details');
      var toggleDetails = function toggleDetails(open) {
        if (!details) {
          return;
        }
        details.classList.toggle('is-open', open);
        details.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (details_btn) {
          details_btn.classList.toggle('is-open', open);
          details_btn.setAttribute('aria-label', open ? 'Hide combat details' : 'Show combat details');
        }
      };
      if (details_btn) {
        details_btn.onclick = function (e) {
          e.preventDefault();
          toggleDetails(!details.classList.contains('is-open'));
        };
      }
      this.bindOverlayPreferenceControl();
    }
  }, {
    key: "factionLabel",
    value: function factionLabel() {
      var power = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return power === 'central' ? 'Central Powers' : 'Allied Powers';
    }
  }, {
    key: "formatRollModifier",
    value: function formatRollModifier(roll, drm) {
      var mod = parseInt(drm) || 0;
      var op = mod >= 0 ? '+' : '-';
      var abs = Math.abs(mod);
      return "<span class=\"calc-roll\">".concat(roll, "</span><span class=\"calc-op\">").concat(op, "</span><span class=\"calc-mod\">").concat(abs, "</span>");
    }

    // Exact content crops from dice.png (1536×1024). Each face is a 224×224 square
    // centered on the non-transparent die art (not the full 256×512 grid cell).
    // red/central row y≈236; blue/allies row y≈556.
  }, {
    key: "dieSourceRect",
    value: function dieSourceRect(face) {
      var power = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'central';
      var CROP = 224;
      // [x, y] top-left of 224×224 source rectangle for faces 1–6
      var central = [[30, 236], [282, 236], [532, 236], [782, 236], [1031, 236], [1281, 236]];
      var allies = [[31, 556], [282, 556], [532, 556], [782, 556], [1031, 556], [1281, 556]];
      var f = parseInt(face) || 1;
      if (f < 1) {
        f = 1;
      }
      if (f > 6) {
        f = 6;
      }
      var xy = (power === 'central' ? central : allies)[f - 1];
      return {
        x: xy[0],
        y: xy[1],
        w: CROP,
        h: CROP,
        sheet_w: 1536,
        sheet_h: 1024
      };
    }
  }, {
    key: "setDieSprite",
    value: function setDieSprite(el, face) {
      var power = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'central';
      if (!el) {
        return;
      }
      var f = parseInt(face) || 1;
      if (f < 1) {
        f = 1;
      }
      if (f > 6) {
        f = 6;
      }
      var src = this.dieSourceRect(f, power);
      el.classList.add('loss-overlay-die-sprite');
      el.classList.toggle('is-central', power === 'central');
      el.classList.toggle('is-allies', power !== 'central');
      el.style.setProperty('--die-src-x', String(src.x));
      el.style.setProperty('--die-src-y', String(src.y));
      el.style.setProperty('--die-crop', String(src.w));
      el.style.setProperty('--die-sheet-w', String(src.sheet_w));
      el.style.setProperty('--die-sheet-h', String(src.sheet_h));
      el.setAttribute('aria-label', "".concat(this.factionLabel(power), " rolled ").concat(f));
    }
  }, {
    key: "fireColumnLabel",
    value: function fireColumnLabel(entry) {
      if (!entry) {
        return '-';
      }
      if (entry.max >= 100) {
        return "".concat(entry.min, "+");
      }
      if (entry.min === entry.max) {
        return String(entry.min);
      }
      return "".concat(entry.min, "\u2013").concat(entry.max);
    }
  }, {
    key: "resolveFireColumn",
    value: function resolveFireColumn() {
      var hits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var cp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var shift = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var base = 0;
      for (var i = hits.length - 1; i >= 0; i--) {
        if (hits[i].max >= cp && hits[i].min <= cp) {
          base = i;
          break;
        }
      }
      var col = base + (parseInt(shift) || 0);
      if (col < 0) {
        col = 0;
      }
      if (col >= hits.length) {
        col = hits.length - 1;
      }
      return {
        base: base,
        col: col,
        base_label: this.fireColumnLabel(hits[base]),
        column_label: this.fireColumnLabel(hits[col]),
        result: hits[col] ? hits[col] : null
      };
    }
  }, {
    key: "buildFireTableHtml",
    value: function buildFireTableHtml() {
      var hits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selected_col = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var selected_roll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var accent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'red';
      var head = "<thead><tr><th class=\"roll-head\">Roll</th>";
      for (var c = 0; c < hits.length; c++) {
        head += "<th class=\"".concat(c === selected_col ? 'is-selected-col' : '', "\">").concat(this.fireColumnLabel(hits[c]), "</th>");
      }
      head += "</tr></thead>";
      var body = "<tbody>";
      for (var roll = 1; roll <= 6; roll++) {
        body += "<tr class=\"".concat(roll === selected_roll ? 'is-selected-row' : '', "\">");
        body += "<th class=\"roll-label\">".concat(roll, "</th>");
        for (var _c = 0; _c < hits.length; _c++) {
          var val = hits[_c][roll];
          var cell = val === undefined || val === null ? '—' : val;
          var cls = [];
          if (_c === selected_col) {
            cls.push('is-selected-col');
          }
          if (roll === selected_roll) {
            cls.push('is-selected-row');
          }
          if (_c === selected_col && roll === selected_roll) {
            cls.push('is-result-cell');
          }
          body += "<td class=\"".concat(cls.join(' '), "\">").concat(cell === 0 ? '—' : cell, "</td>");
        }
        body += "</tr>";
      }
      body += "</tbody>";
      return "<div class=\"pog-fire-table-wrap accent-".concat(accent, "\"><table class=\"pog-fire-table\">").concat(head).concat(body, "</table></div>");
    }
  }, {
    key: "buildFireCalcBlock",
    value: function buildFireCalcBlock() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var drm = parseInt(opts.drm) || 0;
      var drm_text = drm === 0 ? '0' : drm > 0 ? "+".concat(drm) : "\u2212".concat(Math.abs(drm));
      var column_text = opts.column_label;
      if (opts.shift && opts.base_label !== opts.column_label) {
        column_text = "".concat(opts.column_label, " <span class=\"calc-muted\">(from ").concat(opts.base_label, ")</span>");
      }
      var notes = '';
      if (opts.notes && opts.notes.length) {
        notes = "<ul class=\"fire-calc-notes\">".concat(opts.notes.map(function (n) {
          return "<li>".concat(n, "</li>");
        }).join(''), "</ul>");
      }
      return "\n      <section class=\"fire-calc ".concat(opts.accent, "\">\n        <h3 class=\"fire-calc-title\">").concat(opts.title, "</h3>\n        <div class=\"fire-calc-layout\">\n          <dl class=\"fire-calc-summary\">\n            <div><dt>Combat Strength</dt><dd>").concat(opts.cp, "</dd></div>\n            <div><dt>Fire Table</dt><dd>").concat(opts.table_name, "</dd></div>\n            <div><dt>Column</dt><dd>").concat(column_text, "</dd></div>\n            <div><dt>Die Roll</dt><dd>").concat(opts.roll, "</dd></div>\n            <div><dt>Modifier</dt><dd>").concat(drm_text, "</dd></div>\n            <div><dt>Modified Roll</dt><dd>").concat(opts.modified_roll, "</dd></div>\n            <div class=\"fire-calc-result\"><dt>Result</dt><dd>").concat(opts.hits, " hits</dd></div>\n          </dl>\n          <div class=\"fire-calc-table\">\n            <div class=\"fire-calc-table-label\">").concat(opts.table_name, " Fire Table</div>\n            ").concat(this.buildFireTableHtml(opts.hits_table, opts.column_index, opts.modified_roll, opts.accent), "\n          </div>\n        </div>\n        ").concat(notes, "\n      </section>\n    ");
    }
  }, {
    key: "fillCalculationDetails",
    value: function fillCalculationDetails() {
      var combat = this.mod.game.state.combat;
      var space = this.mod.game.spaces[combat.key];
      var snap = this.fireSnapshot();
      var fires = document.querySelector('.loss-overlay .loss-overlay-calc-fires');
      var notes_el = document.querySelector('.loss-overlay .loss-overlay-calc-notes');
      if (!fires || !notes_el) {
        return;
      }
      var attacker_cp = parseInt(snap.attacker_cp);
      var defender_cp = parseInt(snap.defender_cp);
      if (isNaN(attacker_cp)) {
        attacker_cp = parseInt(combat.attacker_strength) || 0;
      }
      if (isNaN(defender_cp)) {
        defender_cp = parseInt(combat.defender_strength) || 0;
      }
      var attacker_hits_table = combat.attacker_table === 'corps' ? this.mod.returnCorpsFireTable() : this.mod.returnArmyFireTable();
      var defender_hits_table = combat.defender_table === 'corps' ? this.mod.returnCorpsFireTable() : this.mod.returnArmyFireTable();
      var attacker_col = this.resolveFireColumn(attacker_hits_table, attacker_cp, combat.attacker_column_shift);
      var defender_col = this.resolveFireColumn(defender_hits_table, defender_cp, combat.defender_column_shift);
      var attacker_accent = combat.attacker_power === 'central' ? 'red' : 'blue';
      var defender_accent = combat.defender_power === 'central' ? 'red' : 'blue';
      var attacker_notes = [];
      var defender_notes = [];
      var a_shift = parseInt(combat.attacker_column_shift) || 0;
      var d_shift = parseInt(combat.defender_column_shift) || 0;
      if (a_shift !== 0) {
        attacker_notes.push("Column shift ".concat(a_shift > 0 ? '+' : '').concat(a_shift, " applied to attacker fire."));
      }
      if (d_shift !== 0) {
        defender_notes.push("Column shift ".concat(d_shift > 0 ? '+' : '').concat(d_shift, " applied to defender fire."));
      }
      if (space.fort > 0 && snap.defender_cp != null) {
        defender_notes.push("Fort strength included in defender combat power used for fire.");
      }

      // Attacker fire → hits on defender; defender fire → hits on attacker
      fires.innerHTML = this.buildFireCalcBlock({
        title: "".concat(this.factionLabel(combat.attacker_power), " Fire"),
        accent: attacker_accent,
        cp: attacker_cp,
        table_name: combat.attacker_table === 'corps' ? 'Corps' : 'Army',
        column_label: attacker_col.column_label,
        base_label: attacker_col.base_label,
        shift: a_shift,
        column_index: attacker_col.col,
        roll: combat.attacker_roll,
        drm: combat.attacker_drm,
        modified_roll: combat.attacker_modified_roll,
        hits: snap.defender_hits,
        hits_table: attacker_hits_table,
        notes: attacker_notes
      }) + this.buildFireCalcBlock({
        title: "".concat(this.factionLabel(combat.defender_power), " Fire"),
        accent: defender_accent,
        cp: defender_cp,
        table_name: combat.defender_table === 'corps' ? 'Corps' : 'Army',
        column_label: defender_col.column_label,
        base_label: defender_col.base_label,
        shift: d_shift,
        column_index: defender_col.col,
        roll: combat.defender_roll,
        drm: combat.defender_drm,
        modified_roll: combat.defender_modified_roll,
        hits: snap.attacker_hits,
        hits_table: defender_hits_table,
        notes: defender_notes
      });
      var note_bits = [];
      var terrain = space.terrain || 'clear';
      if (terrain && terrain !== 'normal' && terrain !== 'clear') {
        note_bits.push("Terrain: <strong>".concat(terrain, "</strong>"));
      } else {
        note_bits.push("Terrain: <strong>clear</strong>");
      }
      if (space.trench > 0) {
        note_bits.push("Trench level <strong>".concat(space.trench, "</strong>"));
      }
      if (space.fort > 0) {
        note_bits.push("Fort <strong>".concat(space.fort, "</strong>"));
      } else if (space.fort == -1) {
        note_bits.push("Fort destroyed");
      }
      if (combat.flank_attack) {
        note_bits.push("Flank attack (".concat(combat.flank_attack === 'attacker' ? 'attacker success' : 'defender success', ")"));
      }
      var cards = [];
      for (var z = 0; z < this.mod.game.state.cc_allies_active.length; z++) {
        cards.push(this.mod.popup(this.mod.game.state.cc_allies_active[z]));
      }
      for (var _z = 0; _z < this.mod.game.state.cc_central_active.length; _z++) {
        cards.push(this.mod.popup(this.mod.game.state.cc_central_active[_z]));
      }
      if (cards.length) {
        note_bits.push("Combat cards: ".concat(cards.join(' ')));
      }
      notes_el.innerHTML = note_bits.length ? "<div class=\"calc-context\">".concat(note_bits.map(function (b) {
        return "<div>".concat(b, "</div>");
      }).join(''), "</div>") : '';
    }
  }, {
    key: "unitLocationLabel",
    value: function unitLocationLabel(unit) {
      var spacekey = unit.spacekey;
      if (this.mod.game.spaces[spacekey] && this.mod.game.spaces[spacekey].name) {
        return this.mod.game.spaces[spacekey].name;
      }
      return spacekey || "\xA0";
    }
  }, {
    key: "isCorpsUnit",
    value: function isCorpsUnit(unit) {
      if (!unit) {
        return false;
      }
      // Prefer key — reliable for freshly cloned replacement corps after army loss
      if (unit.key && unit.key.indexOf('army') > -1) {
        return false;
      }
      if (unit.key && unit.key.indexOf('corps') > -1) {
        return true;
      }
      if (unit.corps) {
        return true;
      }
      if (unit.army) {
        return false;
      }
      return false;
    }
  }, {
    key: "applyUnitTypeClass",
    value: function applyUnitTypeClass(el, unit) {
      if (!el) {
        return;
      }
      var corps = this.isCorpsUnit(unit);
      el.classList.toggle('is-corps', corps);
      el.classList.toggle('is-army', !corps);
      if (unit && unit.key) {
        el.dataset.key = unit.key;
      }
    }
  }, {
    key: "unitTokenInnerHtml",
    value: function unitTokenInnerHtml(unit) {
      var img = this.mod.returnUnitImage(unit);
      var loc = this.unitLocationLabel(unit);
      return "<div class=\"loss-overlay-unit-token\">".concat(img, "</div><div class=\"loss-overlay-unit-spacekey\">").concat(loc, "</div>");
    }
  }, {
    key: "unitCardHtml",
    value: function unitCardHtml(unit, idx) {
      var key = unit.key;
      var spacekey = unit.spacekey;
      var damaged = unit.damaged ? 1 : 0;
      var type_class = this.isCorpsUnit(unit) ? 'is-corps' : 'is-army';
      return "<div class=\"loss-overlay-unit ".concat(type_class, "\" data-spacekey=\"").concat(spacekey, "\" data-key=\"").concat(key, "\" data-damaged=\"").concat(damaged, "\" id=\"").concat(idx, "\">").concat(this.unitTokenInnerHtml(unit), "</div>");
    }
  }, {
    key: "overlayUnitCard",
    value: function overlayUnitCard(my_qs, idx) {
      var el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (el) {
        return el;
      }
      if (!my_qs) {
        return null;
      }
      var container = document.querySelector(my_qs);
      if (!container) {
        return null;
      }
      return container.querySelector(".loss-overlay-unit[id=\"".concat(idx, "\"]"));
    }
  }, {
    key: "renderToAssignAdditionalStepwiseLoss",
    value: function renderToAssignAdditionalStepwiseLoss() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.board_mode) {
        this.exitBoardMode();
      }
      var qs_defender = '.loss-overlay .units.defender';
      var defender_units = this.mod.returnDefenderUnits();
      var attacker_units = this.mod.returnAttackerUnits();
      this.units = defender_units;
      var terrain = this.mod.game.spaces[this.mod.game.state.combat.key].terrain;
      this.moves = [];
      this.number_of_hits_assignable_defender_units = 0;
      this.sole_defender_unit = null;
      this.sole_defender_unit_id = null;
      this.assignment_faction = 'defender';
      this.i_am_assigning = true;
      this.faction = 'defender';
      for (var i = 0; i < defender_units.length; i++) {
        if (!defender_units[i].destroyed) {
          this.number_of_hits_assignable_defender_units++;
          this.sole_defender_unit = defender_units[i];
          this.sole_defender_unit_id = i;
        }
      }

      // one eligible unit: apply the extra step without the picker overlay
      // a reduced sole corps is the last step and cannot be eliminated to cancel the retreat;
      // a reduced army still has a step (replace with corps) and may take the hit
      if (this.number_of_hits_assignable_defender_units == 1 && this.sole_defender_unit) {
        if (this.sole_defender_unit.damaged && this.sole_defender_unit.corps) {
          this.mod.playerHandleRetreat();
          return;
        }
        this.loss_factor = 0;
        this.assignHitToUnit(this.sole_defender_unit, this.sole_defender_unit.spacekey, this.sole_defender_unit.key, this.sole_defender_unit_id, null, false, qs_defender, 'defender', true);
        return;
      }
      this.loss_factor = 0;
      this.board_bind = {
        am_i_the_attacker: false,
        my_qs: qs_defender,
        faction: 'defender',
        just_one_more_hit: true
      };
      if (!this.overlayEnabled()) {
        this.enterBoardMode();
        this.attachEvents(false, qs_defender, 'defender', true);
        return;
      }
      this.overlay.show(LossTemplate(terrain));
      this.fillPresentationChrome(attacker_units, defender_units);
      this.fillCalculationDetails();
      this.updateInstructions('Defender — Take Additional Hit to Cancel Retreat', 'action');
      for (var _i7 = 0; _i7 < defender_units.length; _i7++) {
        if (defender_units[_i7].destroyed) {
          continue;
        }
        this.app.browser.addElementToSelector(this.unitCardHtml(defender_units[_i7], _i7), qs_defender);
      }
      this.attachEvents(false, qs_defender, 'defender', true);
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var assign_hits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.board_mode) {
        this.exitBoardMode();
      }
      this.faction = faction;
      this.assignment_faction = faction;
      var am_i_the_attacker = false;
      var space = this.mod.game.spaces[this.mod.game.state.combat.key];
      var terrain = space.terrain;
      var attacker_units;
      var defender_units;
      this.number_of_hits_assignable_attacker_units = 0;
      this.number_of_hits_assignable_defender_units = 0;
      this.my_hits_auto_assigned = 0;
      this.hits_already_assigned = 0;
      var qs_attacker = '.loss-overlay .units.attacker';
      var qs_defender = '.loss-overlay .units.defender';
      var my_qs = '.loss-overlay .units.defender';
      attacker_units = this.mod.returnAttackerUnits();
      defender_units = this.mod.returnDefenderUnits();
      this.rememberCombatRoster(attacker_units, defender_units);
      this.units = defender_units;
      if (faction == this.mod.game.state.combat.attacking_faction || faction === 'attacker') {
        am_i_the_attacker = true;
        my_qs = '.loss-overlay .units.attacker';
        this.units = attacker_units;
      }
      if (am_i_the_attacker) {
        this.starting_units = JSON.parse(JSON.stringify(attacker_units));
        this.starting_loss_factor = this.mod.game.state.combat.attacker_loss_factor;
        this.loss_factor = this.starting_loss_factor;
      } else {
        this.starting_units = JSON.parse(JSON.stringify(defender_units));
        this.starting_loss_factor = this.mod.game.state.combat.defender_loss_factor;
        this.loss_factor = this.starting_loss_factor;
      }
      for (var z = 0; z < this.units.length; z++) {
        if (this.units[z].damaged_this_combat) {
          this.hits_already_assigned = 1;
        }
      }
      this.moves = [];
      for (var i = 0; i < attacker_units.length; i++) {
        if (!attacker_units[i].destroyed) {
          this.number_of_hits_assignable_attacker_units++;
          this.sole_attacker_unit = attacker_units[i];
          this.sole_attacker_unit_id = i;
        }
      }
      for (var _i8 = 0; _i8 < defender_units.length; _i8++) {
        if (!defender_units[_i8].destroyed) {
          this.number_of_hits_assignable_defender_units++;
          this.sole_defender_unit = defender_units[_i8];
          this.sole_defender_unit_id = _i8;
        }
      }
      var am_iii_the_attacker = false;
      if (this.mod.game.player == this.mod.returnPlayerOfFaction(this.mod.game.state.combat.attacker_power)) {
        am_iii_the_attacker = true;
      }
      this.i_am_assigning = am_iii_the_attacker && faction == 'attacker' || !am_iii_the_attacker && faction == 'defender';
      this.board_bind = {
        am_i_the_attacker: am_i_the_attacker,
        my_qs: my_qs,
        faction: faction,
        just_one_more_hit: false
      };
      var use_board = !this.overlayEnabled();
      if (use_board) {
        this.enterBoardMode();
      } else {
        this.overlay.show(LossTemplate(terrain));
        for (var _i9 = 0; _i9 < attacker_units.length; _i9++) {
          if (!attacker_units[_i9].destroyed) {
            this.app.browser.addElementToSelector(this.unitCardHtml(attacker_units[_i9], _i9), qs_attacker);
          }
        }
        for (var _i0 = 0; _i0 < defender_units.length; _i0++) {
          if (!defender_units[_i0].destroyed) {
            this.app.browser.addElementToSelector(this.unitCardHtml(defender_units[_i0], _i0), qs_defender);
          }
        }
        this.fillPresentationChrome(attacker_units, defender_units);
        this.fillCalculationDetails();
      }
      var snap = this.fireSnapshot();
      var assigning_power = faction == 'attacker' ? this.mod.game.state.combat.attacker_power : this.mod.game.state.combat.defender_power;
      var assigning_name = assigning_power === 'central' ? 'Central Powers' : 'Allied Powers';
      var live_hits = faction == 'attacker' ? this.mod.game.state.combat.attacker_loss_factor : this.mod.game.state.combat.defender_loss_factor;
      var at_fire_hits = faction == 'attacker' ? snap.attacker_hits : snap.defender_hits;
      var flank_note = '';
      if (live_hits != at_fire_hits) {
        flank_note = " (flank-adjusted from ".concat(at_fire_hits, ")");
      }
      if (this.i_am_assigning) {
        this.updateInstructions("".concat(assigning_name, " \u2014 Assign ").concat(this.loss_factor, " Damage Now").concat(flank_note), 'action');
      } else {
        this.updateInstructions("".concat(assigning_name, " assigning ").concat(live_hits, " hits").concat(flank_note), 'waiting');
      }
      if (assign_hits && am_iii_the_attacker == 1 && faction == 'attacker') {
        this.attachEvents(am_i_the_attacker, my_qs, faction);
      }
      if (assign_hits && am_iii_the_attacker == 0 && faction == 'defender') {
        this.attachEvents(am_i_the_attacker, my_qs, faction);
      }
    }
  }, {
    key: "highlightFiringTable",
    value: function highlightFiringTable() {
      // Legacy no-op: details highlighting is handled by fillCalculationDetails().
    }
  }, {
    key: "assignHitToUnit",
    value: function assignHitToUnit(unit, unit_spacekey, unit_key, idx) {
      var el = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var am_i_the_attacker = arguments.length > 5 ? arguments[5] : undefined;
      var my_qs = arguments.length > 6 ? arguments[6] : undefined;
      var faction = arguments.length > 7 ? arguments[7] : undefined;
      var just_one_more_hit = arguments.length > 8 ? arguments[8] : undefined;
      var paths_self = this.mod;
      console.log('assign hit to unit...');

      //
      // prevents auto-assigning next hit if only 1 unit left
      //
      this.hits_already_assigned = 1;

      //if (unit.destroyed) { alert("destroyed"); }

      var didx = idx;
      var unit_idx = didx;
      var space_idx = paths_self.game.spaces[unit_spacekey].units.indexOf(unit);

      //
      // withdrawal — absorb one corps step without applying damage
      //
      var withdrawal_absorbed = false;
      if (unit.corps && unit.eligible_for_withdrawal_bonus && paths_self.game.state.events.withdrawal && paths_self.game.state.events.withdrawal_bonus_used != 1) {
        try {
          salert('Withdrawal Negates 1 Corps Stepwise Loss...');
        } catch (err) {}
        if (unit.damaged) {
          this.loss_factor -= unit.rloss;
        } else {
          this.loss_factor -= unit.loss;
        }
        paths_self.game.state.events.withdrawal_bonus_used = 1;
        withdrawal_absorbed = true;
        this.updateInstructions("".concat(this.mod.returnFactionName(this.mod.returnFactionOfPlayer(this.mod.game.player)), " \u2014 Assign ").concat(this.loss_factor, " More Damage"), 'action');
      }
      if (withdrawal_absorbed) {
        // skip damage application; fall through to remaining-LF handling below
      } else if (unit.damaged && !unit.destroyed) {
        console.log('assigning hit to damaged unit...');
        this.moves.push("damage\t".concat(unit_spacekey, "\t").concat(unit_key, "\t1\t").concat(paths_self.game.player, "\t").concat(space_idx));
        this.loss_factor -= unit.rloss;
        unit.damaged = true;
        unit.destroyed = true;
        unit.damaged_this_combat = true;
        if (!this.board_mode) {
          var destroyed_card = this.overlayUnitCard(my_qs, idx, el);
          if (destroyed_card) {
            destroyed_card.remove();
          }
        }

        //
        // replace with corps if destroyed
        //
        if (unit.key.indexOf('army') > 0 || unit.key == 'aoi_corps') {
          var corpsbox = 'arbox';
          if (paths_self.returnFactionOfPlayer() == 'central') {
            corpsbox = 'crbox';
          }
          var corpskey = unit.key.split('_')[0] + '_corps';
          if (unit.key == 'mef_army' || unit.key == 'ne_army') {
            corpskey = 'br_corps';
          }
          if (unit.key == 'cau_army') {
            corpskey = 'ru_corps';
          }
          if (unit.key == 'orient_army') {
            corpskey = 'fr_corps';
          }
          if (unit.key == 'yld_army01' || unit.key == 'aoi_corps') {
            corpskey = 'tu_corps';
          }
          var corps_idx = -1;
          var corps_damaged = 0;
          var box = paths_self.game.spaces[corpsbox];
          if (box) {
            for (var z = 0; z < box.units.length; z++) {
              if (box.units[z].key == corpskey && !box.units[z].damaged) {
                corps_idx = z;
                corps_damaged = 0;
                break;
              }
            }
            if (corps_idx == -1) {
              for (var _z2 = 0; _z2 < box.units.length; _z2++) {
                if (box.units[_z2].key == corpskey && box.units[_z2].damaged) {
                  corps_idx = _z2;
                  corps_damaged = 1;
                  break;
                }
              }
            }
          }
          if (corps_idx >= 0) {
            console.log('space has this unit: ' + corpskey);
            var corpsunit = paths_self.cloneUnit(corpskey);
            corpsunit.attacked = 1; // we don't want to give this the op to attack
            corpsunit.damaged_this_combat = true; // used to be an army...
            corpsunit.spacekey = unit.spacekey;
            if (corps_damaged) {
              corpsunit.damaged = true;
            }
            // Replacement corps can still receive the Withdrawal step-ignore.
            if (paths_self.game.state.events.withdrawal == 1 && paths_self.game.state.events.withdrawal_bonus_used != 1) {
              corpsunit.eligible_for_withdrawal_bonus = 1;
            }
            // Defender this.units is the combat space. Pushing both inserts the corps twice.
            var space_units = paths_self.game.spaces[corpsunit.spacekey].units;
            if (this.units !== space_units) {
              space_units.push(corpsunit);
            }
            this.units.push(corpsunit);
            if (am_i_the_attacker) {
              paths_self.game.state.combat.attacker.push({
                key: paths_self.game.state.combat.key,
                unit_idx: space_units.length - 1,
                unit_sourcekey: corpsunit.spacekey
              });
            }
            this.moves.push("add\t".concat(unit.spacekey, "\t").concat(corpskey, "\t").concat(this.mod.game.player, "\tattacked\t").concat(corps_damaged));
            this.moves.push("remove\t".concat(corpsbox, "\t").concat(corpskey, "\t").concat(this.mod.game.player, "\t").concat(corps_damaged));
            box.units.splice(corps_idx, 1);
            if (!this.board_mode) {
              this.app.browser.addElementToSelector(this.unitCardHtml(this.units[this.units.length - 1], this.units.length - 1), my_qs);
              //
              // replace our specified element
              //
              if (el != null) {
                var container = document.querySelector(my_qs);
                el = container.querySelector('.loss-overlay-unit:last-child');
                this.applyUnitTypeClass(el, this.units[this.units.length - 1]);
              } else {
                var _container = document.querySelector(my_qs);
                var new_el = _container ? _container.querySelector('.loss-overlay-unit:last-child') : null;
                this.applyUnitTypeClass(new_el, this.units[this.units.length - 1]);
              }
            }
          }

          //
          // auto-assignment relies on the unit being properly
          // identified. so we assign the first non-destroyed corps
          // as the unit for taking auto-hits assigment...
          //
          var attacker_units = paths_self.returnAttackerUnits();
          var defender_units = paths_self.returnDefenderUnits();
          if (faction == 'attacker') {
            for (var y = 0; y < attacker_units.length; y++) {
              if (!attacker_units[y].destroyed) {
                this.sole_attacker_unit_id = y;
                this.sole_attacker_unit = attacker_units[y];
              }
            }
          }
          if (faction == 'defender') {
            for (var _y = 0; _y < defender_units.length; _y++) {
              if (!defender_units[_y].destroyed) {
                this.sole_defender_unit_id = _y;
                this.sole_defender_unit = defender_units[_y];
              }
            }
          }

          //
          // now handled below...
          //
          if (el != null) {
            this.attachEvents(am_i_the_attacker, my_qs, faction, just_one_more_hit);
          }
        }

        //
        // move to eliminated box
        //
        var f = this.mod.returnPowerOfUnit(unit);
        this.updateInstructions("".concat(this.mod.returnFactionName(this.mod.returnFactionOfPlayer(this.mod.game.player)), " \u2014 Assign ").concat(this.loss_factor, " More Damage"), 'action');
      } else {
        console.log('assigning hit to undamaged unit...');
        this.moves.push("damage\t".concat(unit_spacekey, "\t").concat(unit_key, "\t0\t").concat(this.mod.game.player, "\t").concat(space_idx));
        unit.damaged = true;
        unit.damaged_this_combat = true;
        this.loss_factor -= unit.loss;
        if (!this.board_mode) {
          var damaged_card = this.overlayUnitCard(my_qs, idx, el);
          if (damaged_card) {
            this.applyUnitTypeClass(damaged_card, unit);
            damaged_card.dataset.damaged = '1';
            damaged_card.innerHTML = this.unitTokenInnerHtml(unit);
          }
        }
        this.updateInstructions("".concat(this.mod.returnFactionName(this.mod.returnFactionOfPlayer(this.mod.game.player)), " \u2014 Assign ").concat(this.loss_factor, " More Damage"), 'action');
        console.log('assigning hit to undamaged unit... 2');
      }
      console.log('can we take more losses? ' + this.canTakeMoreLosses());
      if (!this.canTakeMoreLosses()) {
        document.querySelectorAll('.loss-overlay-unit').forEach(function (card) {
          card.onclick = function (e) {};
        });
        for (var i = this.moves.length - 1; i >= 0; i--) {
          this.mod.addMove(this.moves[i]);
        }
        this.mod.game.status = 'processing...';
        this.mod.hud.updateStatus(this.mod.game.status);
        this.mod.hud.updateMenu([]);
        this.mod.hud.updateCards([]);

        // Clear temporary board presentation before any normal re-render so
        // displaySpace cannot reopen loss-assignment stacks via board_mode.
        if (this.board_mode) {
          this.exitBoardMode();
        } else {
          this.mod.displaySpace(unit_spacekey);
          if (this.mod.game.state.combat.key !== unit_spacekey) {
            this.mod.displaySpace(this.mod.game.state.combat.key);
          }
          this.mod.displaySpace('aeubox');
          this.mod.displaySpace('arbox');
          this.mod.displaySpace('ceubox');
          this.mod.displaySpace('crbox');
        }
        this.mod.endTurn();
      } else {
        //
        // redisplay affected spaces while assignment continues
        //
        if (this.board_mode) {
          this.refreshBoardAssignmentUI();
          this.updateBoardHud();
        } else {
          this.mod.displaySpace(unit_spacekey);
          if (this.mod.game.state.combat.key !== unit_spacekey) {
            this.mod.displaySpace(this.mod.game.state.combat.key);
          }
        }

        //
        // automatic hits assignment
        //
        if (el == null) {
          this.attachEvents(am_i_the_attacker, my_qs, faction, just_one_more_hit);
        } else {
          // Refresh red-X markers without waiting for the next click
          this.updateAssignableUnits();
          if (this.board_mode) {
            this.bindBoardClicks(am_i_the_attacker, my_qs, faction, just_one_more_hit);
          }
        }
      }

      //
      // A negative loss factor means hits were cancelled. Reaching exactly
      // zero is a finished assignment; leave the panel up for the retreat notice.
      //
      if (this.loss_factor < 0) {
        if (this.board_mode) {
          this.exitBoardMode();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: "shakeInvalidUnit",
    value: function shakeInvalidUnit(el) {
      if (!el) {
        return;
      }
      el.classList.remove('unassignable-shake');
      void el.offsetWidth;
      el.classList.add('unassignable-shake');
      el.addEventListener('animationend', function () {
        el.classList.remove('unassignable-shake');
      }, {
        once: true
      });
    }

    // Visual + status feedback when stepwise rules forbid assigning to the clicked unit.
  }, {
    key: "rejectInvalidHitAssignment",
    value: function rejectInvalidHitAssignment(el) {
      if (!el) {
        return;
      }
      var msg = "That unit can't take this hit — choose another.";
      if (this.board_mode || el.classList.contains('army-tile')) {
        this.shakeBoardTile(el);
        this.mod.game.status = msg;
        this.mod.hud.updateStatus(msg);
        this.mod.hud.updateMenu([]);
        this.mod.hud.updateCards([]);
        return;
      }
      this.shakeInvalidUnit(el);
      this.updateInstructions(msg, 'action');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(am_i_the_attacker, my_qs, faction) {
      var _this6 = this;
      var just_one_more_hit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var paths_self = this.mod;
      console.log('can take more losses: ' + this.canTakeMoreLosses());
      console.log('just one more hit? ' + just_one_more_hit);
      if (!this.canTakeMoreLosses() && just_one_more_hit == false) {
        for (var i = this.moves.length - 1; i >= 0; i--) {
          paths_self.addMove(this.moves[i]);
        }
        paths_self.game.status = 'processing...';
        paths_self.hud.updateStatus(paths_self.game.status);
        paths_self.hud.updateMenu([]);
        paths_self.hud.updateCards([]);
        if (this.board_mode) {
          this.exitBoardMode();
        }
        paths_self.endTurn();
        return;
      }
      this.board_bind = {
        am_i_the_attacker: am_i_the_attacker,
        my_qs: my_qs,
        faction: faction,
        just_one_more_hit: just_one_more_hit
      };
      console.log('assigning hits? ' + faction);
      console.log('hits assignable def? ' + this.number_of_hits_assignable_defender_units);
      console.log('hits assignable att? ' + this.number_of_hits_assignable_attacker_units);

      // Corps leave no replacement. If the hits cover every remaining step, order does not matter.
      var corps_only = true;
      var hits_to_wipe = 0;
      for (var z = 0; z < this.units.length; z++) {
        var u = this.units[z];
        if (u.destroyed) {
          continue;
        }
        if (!u.corps || u.key == 'aoi_corps') {
          corps_only = false;
          break;
        }
        if (u.damaged) {
          hits_to_wipe += u.rloss;
        } else {
          hits_to_wipe += u.loss + u.rloss;
        }
      }
      if (corps_only && hits_to_wipe > 0 && this.loss_factor >= hits_to_wipe) {
        for (var _z3 = 0; _z3 < this.units.length; _z3++) {
          if (!this.units[_z3].destroyed) {
            this.assignHitToUnit(this.units[_z3], this.units[_z3].spacekey, this.units[_z3].key, _z3, null, am_i_the_attacker, my_qs, faction, just_one_more_hit);
            this.hits_already_assigned = 1;
            this.updateInstructions('All losses have been assigned automatically.', 'resolved');
            return;
          }
        }
      }
      if (faction === 'defender' && this.number_of_hits_assignable_defender_units == 1) {
        var idx = this.sole_defender_unit_id;
        var unit = this.sole_defender_unit;
        var unit_key = this.sole_defender_unit.key;
        var unit_spacekey = this.sole_defender_unit.spacekey;
        console.log('assigning hit to: ' + JSON.stringify(unit));
        this.assignHitToUnit(unit, unit_spacekey, unit_key, idx, null, am_i_the_attacker, my_qs, faction, just_one_more_hit);
        this.hits_already_assigned = 1;
        this.updateInstructions('All losses have been assigned automatically.', 'resolved');
        return;
      }
      if (faction === 'attacker' && this.number_of_hits_assignable_attacker_units == 1) {
        var _idx = this.sole_attacker_unit_id;
        var _unit = this.sole_attacker_unit;
        var _unit_key = this.sole_attacker_unit.key;
        var _unit_spacekey = this.sole_attacker_unit.spacekey;
        console.log('assigning hit to: ' + JSON.stringify(_unit));
        this.assignHitToUnit(_unit, _unit_spacekey, _unit_key, _idx, null, am_i_the_attacker, my_qs, faction, just_one_more_hit);
        this.hits_already_assigned = 1;
        this.updateInstructions('All losses have been assigned automatically.', 'resolved');
        return;
      }
      this.updateAssignableUnits(am_i_the_attacker);
      if (this.board_mode) {
        this.refreshBoardAssignmentUI();
        this.bindBoardClicks(am_i_the_attacker, my_qs, faction, just_one_more_hit);
        this.updateBoardHud();
        return;
      }
      document.querySelectorAll(my_qs + ' .loss-overlay-unit').forEach(function (el) {
        // Replacing a destroyed army adds a corps and rebinds this panel. The
        // old army token remains visible with id="destroyed_unit"; it is no
        // longer an index into units and must not become clickable again.
        var idx = Number(el.id);
        if (!/^\d+$/.test(el.id) || !_this6.units[idx] || _this6.units[idx].destroyed) {
          el.onclick = null;
          return;
        }
        el.onclick = function (e) {
          _this6.updateAssignableUnits();
          var idx = e.currentTarget.id;
          var unit = _this6.units[idx];
          if (!unit || unit.destroyed) {
            return;
          }
          if (just_one_more_hit) {
            if (unit.damaged) {
              var others = 0;
              for (var _z4 = 0; _z4 < _this6.units.length; _z4++) {
                if (_z4 != idx && _this6.units[_z4].destroyed == false) {
                  others++;
                }
              }
              if (others == 0) {
                _this6.rejectInvalidHitAssignment(e.currentTarget);
                return;
              }
            }
          } else {
            if (unit.unassignable == 1) {
              _this6.rejectInvalidHitAssignment(e.currentTarget);
              return;
            }
          }
          var unit_key = e.currentTarget.dataset.key;
          var unit_spacekey = e.currentTarget.dataset.spacekey;
          _this6.assignHitToUnit(unit, unit_spacekey, unit_key, idx, el, am_i_the_attacker, my_qs, faction, just_one_more_hit);
          _this6.hits_already_assigned = 1;
        };
      });
    }
  }, {
    key: "updateAssignableUnits",
    value: function updateAssignableUnits() {
      //
      // unset
      //
      for (var z = 0; z < this.units.length; z++) {
        this.units[z].unassignable = 0;
      }

      //
      // first hit must be to one of these units...
      //
      this.priority_hits_required = 0;
      if (this.hits_already_assigned == 0) {
        var priority_found = 0;
        for (var _z5 = 0; _z5 < this.units.length; _z5++) {
          var u = this.units[_z5];
          if (u.destroyed) {
            continue;
          }
          var priority_step = u.damaged ? u.rloss : u.loss;
          if (this.loss_factor > 0 && priority_step > this.loss_factor) {
            continue;
          }
          if (u.priority > 0 && u.priority > priority_found) {
            priority_found = u.priority;
            for (var zz = 0; zz < this.units.length; zz++) {
              this.units[zz].unassignable = 0;
              this.priority_hits_required = 1;
              if (this.units[zz].priority < u.priority) {
                this.units[zz].unassignable = 1;
              }
            }
          }
        }
      }
      if (this.priority_hits_required == 1) {
        for (var _z6 = 0; _z6 < this.units.length; _z6++) {
          if (this.units[_z6].destroyed) {
            continue;
          }
          var step = this.units[_z6].damaged ? this.units[_z6].rloss : this.units[_z6].loss;
          if (this.loss_factor > 0 && step > this.loss_factor) {
            this.units[_z6].unassignable = 1;
            this.are_any_units_unassignable = 1;
          }
        }
        this.syncUnassignableUI();
        return;
      }

      //
      // calculate maximum deadzone losses
      //
      // the "deadzone" variable associated with all units refers to the difference
      // between the loss factor they take at this step, and the loss-factor they
      // take as a reduced corps.
      //
      // In situations where we have a damaged army AND an undamaged army in our
      // units and the loss factor of the damaged unit + deadzone < 5, while all
      // undamaged armies have loss factors of 3 (individually) we need to assign
      // the hits to our damaged armies first.
      //
      this.are_any_units_unassignable = 0;
      var damaged_armies = false;
      var undamaged_armies = false;
      var corps_in_play = false;
      var corps_damage = 0;
      var undamaged_min_loss = 100;
      var damaged_max_loss = 0;
      for (var _z7 = 0; _z7 < this.units.length; _z7++) {
        this.units[_z7].unassignable = 0;
        if (!this.units[_z7].destroyed) {
          if (this.units[_z7].corps) {
            corps_in_play = true;
            if (this.units[_z7].damaged) {
              corps_damage += 1;
            } else {
              corps_damage += 2;
            }
          } else {
            if (this.units[_z7].army) {
              if (this.units[_z7].damaged) {
                damaged_armies = true;
                var max_loss = this.units[_z7].rloss + 2;
                if (max_loss > damaged_max_loss) {
                  damaged_max_loss = max_loss;
                }
              } else {
                undamaged_armies = true;
                var min_loss = this.units[_z7].loss;
                if (min_loss < undamaged_min_loss) {
                  undamaged_min_loss = min_loss;
                }
              }
            }
          }
        }
      }
      console.log('damaged armies: ' + damaged_armies);
      console.log('undamaged_armies: ' + undamaged_armies);
      console.log('corps_in_play: ' + corps_in_play);
      console.log('corps_damage: ' + corps_damage);
      console.log('undamaged_min_loss: ' + undamaged_min_loss);
      console.log('damaged_max_loss: ' + damaged_max_loss);
      console.log('loss_factor: ' + this.loss_factor);

      //
      // loss factor is the same as the undamaged army, but corps exist
      //
      if (this.loss_factor == undamaged_min_loss && corps_damage > 0 && corps_damage < this.loss_factor) {
        for (var _z8 = 0; _z8 < this.units.length; _z8++) {
          if (this.units[_z8].corps) {
            this.units[_z8].unassignable = 1;
            this.are_any_units_unassignable = 1;
          }
        }
      }

      //
      // we need to force assign hits when the min loss of the smallest
      // undamaged army is LESS than the loss factor, but MORE than the
      // MIN damaged army + its corps potential, and when there are no
      // corps in play that can soak up the remainder
      //
      if (damaged_armies && undamaged_armies) {
        //
        // if the full army + any corps cannot soak up all damage
        //
        if (undamaged_min_loss + corps_damage < this.loss_factor) {
          //
          // but the undamaged army + corps + future hits can...
          //
          if (damaged_max_loss + corps_damage >= this.loss_factor) {
            for (var _z9 = 0; _z9 < this.units.length; _z9++) {
              if (!this.units[_z9].destroyed) {
                if (this.units[_z9].army && !this.units[_z9].damaged) {
                  this.units[_z9].unassignable = 1;
                  this.are_any_units_unassignable = 1;
                }
              }
            }
          }
        }
      }
      for (var _z0 = 0; _z0 < this.units.length; _z0++) {
        if (this.units[_z0].destroyed) {
          continue;
        }
        var _step = this.units[_z0].damaged ? this.units[_z0].rloss : this.units[_z0].loss;
        if (this.loss_factor > 0 && _step > this.loss_factor) {
          this.units[_z0].unassignable = 1;
          this.are_any_units_unassignable = 1;
        }
      }
      this.syncUnassignableUI();
    }
  }, {
    key: "syncUnassignableUI",
    value: function syncUnassignableUI() {
      var _this7 = this;
      if (this.board_mode) {
        document.querySelectorAll('.space.loss-assignment-open .army-tile.loss-board-unit').forEach(function (tile) {
          var idx = parseInt(tile.dataset.lossIdx);
          var unit = _this7.units && _this7.units[idx];
          tile.classList.toggle('loss-board-unassignable', !!(unit && unit.unassignable == 1));
        });
        return;
      }
      document.querySelectorAll('.loss-overlay-unit').forEach(function (el) {
        var unit = _this7.units[el.id];
        el.classList.toggle('unassignable', !!(unit && unit.unassignable == 1));
      });
    }
  }]);
}();
module.exports = LossOverlay;